import { render, staticRenderFns } from "./userMsg.vue?vue&type=template&id=533e67ac&scoped=true&"
import script from "./userMsg.vue?vue&type=script&lang=js&"
export * from "./userMsg.vue?vue&type=script&lang=js&"
import style0 from "./userMsg.vue?vue&type=style&index=0&id=533e67ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e67ac",
  null
  
)

export default component.exports